import { defineMessages } from 'react-intl';

export default defineMessages({
  noToken: {
    id: 'invitation.noToken',
    defaultMessage: 'No token found',
  },
  token: {
    id: 'invitation.token',
    defaultMessage: 'Token: {token}',
  },
  invitationTitlePage: {
    id: 'invitation.invitationTitlePage',
    defaultMessage: 'Invitation',
  },
});
